import { render, staticRenderFns } from "./DetailInserts.vue?vue&type=template&id=6ba96532&"
import script from "./DetailInserts.vue?vue&type=script&lang=js&"
export * from "./DetailInserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports